import { OrgForms } from "./forms";
import { Privilege } from "../models/UserProfileResponse";

export type UserRole =
  | "PlatformOwner"
  | "OrganizationOwner"
  | "Admin"
  | "Manager"
  | "Receptionist"
  | "Staff";

export interface NavItem {
  key: string;
  label: string;
  icon: string; // path to icon or component name
  path?: string; // optional if you use react-router
  form?: number; // privilege form id used to filter access
  allowedRoles?: UserRole[]; // when set, only these roles see the item
}

export const platformOwnerNav: NavItem[] = [
  { key: "dashboard", label: "Dashboard", icon: "dashboard" },
  { key: "organizations", label: "Organizations", icon: "organizations" },
  { key: "users", label: "Users", icon: "users" },
  { key: "analytics", label: "Analytics", icon: "analytics" },
  { key: "subscriptions", label: "Subscriptions / Billing", icon: "billing" },
  { key: "plans", label: "Plans", icon: "plans" },
  { key: "settings", label: "Settings", icon: "settings" },
];

export const organizationOwnerNav: NavItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "dashboard",
    allowedRoles: ["OrganizationOwner", "Admin", "Manager", "Receptionist"],
  },
  {
    key: "my-organization",
    label: "My Organization",
    icon: "organization",
    form: OrgForms.Dashboard,
    allowedRoles: ["OrganizationOwner", "Admin"],
  },
  {
    key: "branches",
    label: "Branches",
    icon: "branches",
    form: OrgForms.Branch,
    allowedRoles: ["OrganizationOwner", "Admin"],
  },
  { key: "users", label: "Users", icon: "users", form: OrgForms.Users },
  { key: "clients", label: "Clients", icon: "clients", form: OrgForms.Clients },
  {
    key: "services",
    label: "Services",
    icon: "services",
    form: OrgForms.Services,
  },
  {
    key: "appointments",
    label: "Appointments",
    icon: "appointments",
    form: OrgForms.Appointments,
  },
  {
    key: "followups",
    label: "Follow-Ups",
    icon: "followups",
    form: OrgForms.Appointments,
  },
  {
    key: "inquiries",
    label: "Inquiries",
    icon: "inquiries",
    form: OrgForms.Inquiries,
  },
  { key: "website-builder", label: "Website Builder", icon: "website", form: OrgForms.WebsiteBuilder },
  { key: "messaging", label: "Messaging", icon: "messaging", form: OrgForms.Messaging },
  { key: "qrcode", label: "QR Code", icon: "qrcode" },
];

export const getNavByRole = (
  role: UserRole | undefined,
  privileges?: Privilege[],
): NavItem[] => {
  switch (role) {
    case "PlatformOwner":
      return privileges && privileges.length > 0
        ? organizationOwnerNav
        : platformOwnerNav;
    case "OrganizationOwner":
    case "Admin":
    case "Manager":
    case "Receptionist":
    case "Staff": {
      const roleScoped = organizationOwnerNav.filter(
        (item) => !item.allowedRoles || item.allowedRoles.includes(role),
      );
      return roleScoped.filter(
        (item) =>
          item.form === undefined ||
          (privileges ?? []).some((p) => p.form === item.form && p.canView),
      );
    }
    default:
      return [];
  }
};
